// Auth contract shared by the server (issuer/verifier) and client (consumer).
// Pure types + small helpers, no runtime deps.
import { primaryEmailOf } from "./db/user.js";
/** Project a stored user down to the client-safe shape. */
export function publicUserFrom(user) {
    return {
        userId: user.userId,
        email: primaryEmailOf(user),
        username: user.username,
        displayName: user.displayName,
        avatarUrl: user.avatarUrl,
        roles: user.roles ?? [],
        pushNotifications: user.pushNotifications,
        tutorialComplete: user.tutorialComplete,
    };
}
/** Username length bounds (inclusive). */
export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 18;
/**
 * Valid usernames: lowercase letters + digits, with `.` / `-` only as separators
 * between alphanumeric segments (no leading/trailing/repeated separators).
 */
const USERNAME_RE = /^[a-z0-9]+(?:[.-][a-z0-9]+)*$/;
/** Normalize user input before validation / storage (trim + lowercase). */
export function normalizeUsername(raw) {
    return raw.trim().toLowerCase();
}
/** Validate a username. Returns null when valid. */
export function validateUsername(raw) {
    const username = normalizeUsername(raw);
    if (!username)
        return "empty";
    if (username.length < USERNAME_MIN_LENGTH)
        return "too_short";
    if (username.length > USERNAME_MAX_LENGTH)
        return "too_long";
    if (!USERNAME_RE.test(username))
        return "invalid";
    return null;
}
//# sourceMappingURL=auth.js.map